import styled, { keyframes, css } from 'styled-components';
import * as Tooltip from '@radix-ui/react-tooltip';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../../foundation/breakpoints/values.js';

var ANIMATION_DISTANCE = 10;
var slideInTop = keyframes(["from{opacity:0;transform:translateY(-", ");}to{opacity:1;transform:translateY(0);}"], pxToRem(ANIMATION_DISTANCE));
var slideInBottom = keyframes(["from{opacity:0;transform:translateY(", ");}to{opacity:1;transform:translateY(0);}"], pxToRem(ANIMATION_DISTANCE));
var slideInLeft = keyframes(["from{opacity:0;transform:translateX(-", ");}to{opacity:1;transform:translateX(0);}"], pxToRem(ANIMATION_DISTANCE));
var slideInRight = keyframes(["from{opacity:0;transform:translateX(", ");}to{opacity:1;transform:translateX(0);}"], pxToRem(ANIMATION_DISTANCE));
var getFixedWidthStyles = function getFixedWidthStyles(width) {
  if (width === undefined) {
    return css(["", "{max-width:90vw;}", "{max-width:40vw;}"], breakpoints.xs, breakpoints.sm);
  }
  return css(["max-width:", ";"], pxToRem(width));
};
var TooltipContent = styled(Tooltip.Content).withConfig({
  displayName: "TooltipContent",
  componentId: "sc-8a335g-0"
})(["padding:", " ", ";border-radius:", ";background-color:", ";z-index:", ";", ";font-size:", ";color:", ";user-select:none;animation-duration:400ms;animation-timing-function:cubic-bezier(0.16,1,0.3,1);will-change:transform,opacity;&[data-state='delayed-open'][data-side='top']{animation-name:", ";}&[data-state='delayed-open'][data-side='right']{animation-name:", ";}&[data-state='delayed-open'][data-side='bottom']{animation-name:", ";}&[data-state='delayed-open'][data-side='left']{animation-name:", ";}"], themeGet('spacing.sm'), themeGet('spacing.md'), themeGet('spacing.sm'), themeGet('colors.gray.1000'), themeGet('zIndex.tooltip'), function (props) {
  return getFixedWidthStyles(props.$width);
}, themeGet('fontSize.small'), themeGet('colors.gray.0'), slideInTop, slideInRight, slideInBottom, slideInLeft);
var TooltipArrow = styled(Tooltip.Arrow).withConfig({
  displayName: "TooltipArrow",
  componentId: "sc-8a335g-1"
})(["fill:", ";"], themeGet('colors.gray.1000'));

export { TooltipArrow, TooltipContent };
